// The status line's collection switcher: a button that opens a filterable list of the account's collections and,
// for MSPs, client accounts. Markup comes from _AuthenticatedLayout.cshtml; this only handles open/close, filtering,
// and keyboard movement. Loaded on every page via global.ts.

function initSwitcher(root: HTMLElement) {
    var button = root.querySelector<HTMLButtonElement>(".switcher-button")!;
    var caret = root.querySelector<HTMLElement>(".switcher-caret")!;
    var panel = root.querySelector<HTMLElement>(".switcher-panel")!;
    var filter = root.querySelector<HTMLInputElement>(".switcher-filter input")!;
    var sections = Array.from(root.querySelectorAll<HTMLElement>(".switcher-section"));
    var rows = Array.from(root.querySelectorAll<HTMLElement>(".switcher-row"));
    var empty = root.querySelector<HTMLElement>(".switcher-empty")!;

    // Collection rows are the links themselves; client rows are forms around a submit button.
    function visibleItems(): HTMLElement[] {
        return rows
            .filter(function (row) { return !row.hidden; })
            .map(function (row) { return row.matches(".switcher-item") ? row : row.querySelector<HTMLElement>(".switcher-item")!; });
    }

    function applyFilter() {
        var query = filter.value.trim().toLowerCase();
        var shown = 0;
        rows.forEach(function (row) {
            var text = row.getAttribute("data-filter") || "";
            row.hidden = query.length > 0 && text.indexOf(query) < 0;
            if (!row.hidden) {
                shown++;
            }
        });
        sections.forEach(function (section) {
            var label = section.querySelector<HTMLElement>(".switcher-section-label");
            if (label) {
                label.hidden = !section.querySelector(".switcher-row:not([hidden])");
            }
        });
        empty.hidden = shown > 0;
    }

    function open() {
        panel.hidden = false;
        button.setAttribute("aria-expanded", "true");
        caret.textContent = "▴";
        filter.value = "";
        applyFilter();
        // On touch screens, focusing the filter would throw the keyboard up over the list.
        if (window.matchMedia("(pointer: fine)").matches) {
            filter.focus();
        }
    }

    function close() {
        panel.hidden = true;
        button.setAttribute("aria-expanded", "false");
        caret.textContent = "▾";
    }

    function isOpen(): boolean {
        return !panel.hidden;
    }

    // Up/down walks the filter box and the visible rows as one list.
    function moveFocus(direction: number) {
        var stops: HTMLElement[] = ([filter] as HTMLElement[]).concat(visibleItems());
        var index = stops.indexOf(document.activeElement as HTMLElement);
        var next = index + direction;
        if (next < 0) {
            next = stops.length - 1;
        }
        if (next >= stops.length) {
            next = 0;
        }
        stops[next].focus();
    }

    button.addEventListener("click", function () {
        if (isOpen()) {
            close();
        }
        else {
            open();
        }
    });

    filter.addEventListener("input", applyFilter);

    root.addEventListener("keydown", function (e) {
        if (!isOpen()) {
            return;
        }
        if (e.key === "Escape") {
            close();
            button.focus();
            e.preventDefault();
        }
        else if (e.key === "ArrowDown") {
            moveFocus(1);
            e.preventDefault();
        }
        else if (e.key === "ArrowUp") {
            moveFocus(-1);
            e.preventDefault();
        }
        else if (e.key === "Enter" && e.target === filter) {
            var first = visibleItems()[0];
            if (first) {
                first.click();
            }
            e.preventDefault();
        }
    });

    document.addEventListener("click", function (e) {
        if (isOpen() && !root.contains(e.target as Node)) {
            close();
        }
    });

    applyFilter();
}

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll<HTMLElement>("[data-collection-switcher]").forEach(initSwitcher);
});

export {};
